import { MessageCircle, ShieldCheck, Clock, Video } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionEyebrow from "@/components/SectionEyebrow";
import Seo from "@/components/Seo";
import BookingFlow from "@/components/BookingFlow";
import { useLang } from "@/context/LanguageContext";
import { WHATSAPP_LINK, CONSULTATION_PRICE } from "@/lib/config";

export default function Booking() {
    const { t } = useLang();
    return (
        <div data-testid="booking-page" className="relative">
            <Seo
                title="Book Your Consultation · Abhijit JK"
                description="Book a 60-minute one-to-one business strategy call with Abhijit JK. Select a date and slot, pay securely, and confirm your session."
            />

            <section className="mx-auto max-w-7xl px-6 pt-20 pb-8 lg:px-10">
                <Reveal>
                    <SectionEyebrow>{t("booking_eyebrow")}</SectionEyebrow>
                </Reveal>
                <Reveal delay={0.1}>
                    <h1 className="mt-6 max-w-4xl font-display text-4xl font-semibold leading-[1.04] tracking-tighter sm:text-5xl lg:text-6xl">
                        {t("booking_pre")}{" "}
                        <span className="gold-text">{t("booking_gold")}</span>
                    </h1>
                </Reveal>
                <Reveal delay={0.15}>
                    <div className="mt-6 flex flex-wrap items-center gap-5 text-sm text-white/65">
                        <span className="inline-flex items-center gap-2"><Clock size={15} className="text-gold-300" /> 60 minutes · Mon–Fri</span>
                        <span className="inline-flex items-center gap-2"><Video size={15} className="text-gold-300" /> Online · Google Meet</span>
                        <span className="inline-flex items-center gap-2"><ShieldCheck size={15} className="text-gold-300" /> Secure Razorpay payment</span>
                        <span className="gold-text font-display text-xl font-semibold">{CONSULTATION_PRICE}</span>
                    </div>
                </Reveal>
            </section>

            <section className="mx-auto max-w-4xl px-6 pb-16 lg:px-10">
                <Reveal>
                    <div className="glass glow-border rounded-lg p-8 md:p-12">
                        <BookingFlow />
                    </div>
                </Reveal>

                <Reveal delay={0.1}>
                    <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-lg glass p-6 sm:flex-row">
                        <p className="text-sm text-white/70">Having trouble booking?</p>
                        <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" data-testid="booking-whatsapp" className="ghost-button inline-flex items-center gap-2">
                            <MessageCircle size={14} /> WhatsApp Us
                        </a>
                    </div>
                </Reveal>
            </section>
        </div>
    );
}
